import React, { useEffect, useState, useMemo, createContext } from 'react'
import { Outlet, useNavigate, useLocation } from 'react-router-dom'
import { Api, getSession } from '../api/Assinafy'
import Dashboard from '../layout/Dashboard'
import _ from 'lodash'
import {
  getPendingRedirectWithAction,
  shouldSkipPendingActionsRedirect,
} from '../utils/accountPendingActions'

export const SessionContext = createContext();

const DashboardRoute = ({ ...props }) => {
  const [session, setSession] = useState({})
  const navigate = useNavigate()
  const location = useLocation()
  const currentSession = getSession()
  const { user, accounts } = currentSession
  const { state } = location
  const hasWorkspace = Array.isArray(accounts) && accounts.length > 0
  const isConnectedApps = location.pathname === '/dashboard/account/connected-apps'
  const pendingActionsCheckKey = 'pendingActionsChecked'

  const memoSession = useMemo(() => [session, setSession], [session])

  useEffect(() => {
    if (!user) {
      navigate('/', { state: state })
    }
  }, [navigate, state, user])

  useEffect(() => {
    if (user && !hasWorkspace && !isConnectedApps) {
      navigate('/workspace/new', { replace: true })
    }
  }, [hasWorkspace, isConnectedApps, navigate, user])

  useEffect(() => {
    if (!_.isEmpty(session)) {
      return
    }
    
    setSession(getSession())
  }, [user])

  useEffect(() => {
    if (!user || _.isEmpty(session)) {
      return
    }
    if (sessionStorage.getItem(pendingActionsCheckKey) === '1') {
      return
    }
    const accountId = session.accounts?.[0]?.id
    if (!accountId) {
      sessionStorage.setItem(pendingActionsCheckKey, '1')
      return
    }
    if (shouldSkipPendingActionsRedirect(location.pathname)) {
      sessionStorage.setItem(pendingActionsCheckKey, '1')
      return
    }

    const pendingApi = Api("account/pendingActions")
    if (!pendingApi) {
      sessionStorage.setItem(pendingActionsCheckKey, '1')
      return
    }

    let cancelled = false
    pendingApi(accountId)
      .then((res) => {
        sessionStorage.setItem(pendingActionsCheckKey, '1')
        if (cancelled || res?.status !== 200) {
          return
        }
        const actions = res?.data?.data?.actions
        const redirect = getPendingRedirectWithAction(actions, accountId)
        if (redirect?.path && redirect.action?.id) {
          navigate(redirect.path, {
            replace: true,
            state: {
              pendingActionResolve: {
                accountId,
                actionId: redirect.action.id,
                type: redirect.action.type,
              },
            },
          })
        }
      })
      .catch(() => {
        sessionStorage.setItem(pendingActionsCheckKey, '1')
      })

    return () => {
      cancelled = true
    }
  }, [user, session, navigate, location.pathname])

  if (!user || _.isEmpty(session)) {
    return (<></>)
  }

  return (<SessionContext.Provider value={memoSession}>
    <Dashboard {...props} >
      <Outlet />
    </Dashboard>
  </SessionContext.Provider>)
};

export default DashboardRoute;
